import { EvaluationType } from '../../shared/types/intervieweeType';
import { TagColors } from '../../shared/styled-components/styled_tags';
import { SocialProvider } from '../../shared/types/userTypes';

export class StringUtils {
  public static randomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  public static formatPrice = (val: number) => {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  public static sanitize = (string: string) => {
    return string.replaceAll(/\\/g, '\\005c').replaceAll("'", '\\0027').replaceAll('\n', ' \\A ');
  };

  public static formatPhoneNumber(number: string) {
    return number;
    // Remove any non-number characters
    const cleanString = number.replace(/[^0-9]+/g, '');
    let formatted = '';

    if (cleanString.length < 9) {
      return cleanString;
    }

    if (cleanString.length === 9) {
      for (let i = 0; i < cleanString.length; i++) {
        if (i == 2 || i == 5) {
          formatted += '-';
        }
        formatted += cleanString[i];
      }
    }

    if (cleanString.length === 10) {
      for (let i = 0; i < cleanString.length; i++) {
        if (i === 3 || i === 6) {
          formatted += '-';
        }
        formatted += cleanString[i];
      }
    }

    if (cleanString.length === 11) {
      for (let i = 0; i < cleanString.length; i++) {
        if (i === 3 || i == 7) {
          formatted += '-';
        }
        formatted += cleanString[i];
      }
    }

    formatted.replace(/--+/g, '-');
    if (formatted.length > 13) {
      formatted = formatted.slice(0, 13);
    }

    return formatted;
  }

  public static evaluationToKorean = (evaluation: EvaluationType) => {
    switch (evaluation) {
      case 'excellent':
        return '우수';
      case 'average':
        return '보통';
      case 'bad':
        return '미흡';
      case 'other':
        return '기타';
    }
  };
  public static evaluationTagColor = (evaluation: EvaluationType): TagColors => {
    switch (evaluation) {
      case 'excellent':
        return 'primary';
      case 'average':
        return 'green';
      case 'bad':
        return 'error';
      case 'other':
        return 'mono';
    }
  };

  public static socialProviderToKorean = (provider: SocialProvider) => {
    switch (provider) {
      case 'google':
        return '구글';
      case 'kakao':
        return '카카오톡';
      case 'naver':
        return '네이버';
      case 'apple':
        return '애플';
    }
  };
}
